import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  MenuItem,
  ListItemText,
  SelectChangeEvent,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputBase,
  Paper,
  Typography,
  TextField,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import _ from "lodash";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import {
  AssetUnitsMaster,
  ProjectUnitSuffix,
  AssetTypes,
} from "../../../types/project";
import MultiSelect from "../../common/MultiSelect";

interface AddIntelliFiberUnitProps {
  assetLookup: AssetUnitsMaster[] | undefined;
  projectId: string | undefined;
  addProjectUnitsV2?: (units: AssetUnitsMaster[]) => Promise<boolean>;
  deleteIntelliFiberUnit?: (units: AssetTypes[]) => Promise<boolean>;
  setAlertMessage: any;
  setShowAlert: any;
  fetchAssets: any;
  projectAssets: any;
  projectRawAssets: any;
  fetchProjectAssets: any;
  searchTerm: string | undefined;
  setSearchTerm: any;
  editDialogOpen: boolean;
  setEditDialogOpen: any;
  editProps: any;
  setEditProps: any;
  assetTypes;
  assetGroups;
  assetSuffixes;
  getAssetTypesV2?: () => Promise<AssetTypes[]>;
  generateNewUnitID?: () => Number;
  addNewUnitsV2?: (units: AssetTypes[]) => Promise<boolean>;
  intelliFiberUserRoles: any;
  user: any;
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AddIntelliFiberUnit: React.FC<{ config: AddIntelliFiberUnitProps }> = ({
  config,
}) => {
  const {
    assetLookup,
    getAssetTypesV2,
    projectId,
    addProjectUnitsV2,
    deleteIntelliFiberUnit,
    setAlertMessage,
    setShowAlert,
    fetchAssets,
    projectAssets,
    projectRawAssets,
    fetchProjectAssets,
    searchTerm,
    setSearchTerm,
    editDialogOpen,
    setEditDialogOpen,
    editProps,
    setEditProps,
    assetTypes,
    assetGroups,
    generateNewUnitID,
    addNewUnitsV2,
    intelliFiberUserRoles,
    user,
  } = config;
  const [category, setCategory] = useState("");
  // const [unitType, setUnitType] = useState("");
  const [initUnitType, setInitUnitType] = useState<string[]>([]);
  const [selectedUnitType, setSelectedUnitType] = useState<string[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [newUnitOpen, setNewUnitOpen] = useState<boolean>(false);
  const [units, setUnits] = useState<ProjectUnitSuffix[]>([]);
  // const [configSuffixes, setConfigSuffixes] = useState<string[]>([]);
  // const [deleteRecords, setDeleteRecords] = React.useState<ProjectUnitSuffix[]>(
  //   []
  // );
  const [assetType, setAssetType] = useState("");
  const [formChanged, setFormChanged] = useState<boolean>(false);
  const [invalidInput, setInvalidInput] = useState<boolean>(false);

  // let oldUnits: ProjectUnitSuffix[] = [];
  // if (editDialogOpen === true) {
  //   oldUnits = projectRawAssets.filter(
  //     ({ AssetGroupID, AssetTypeID, SuffixID, OBJECTID }) => {
  //       if (AssetGroupID === category && AssetTypeID === unitType) {
  //         return {
  //           AssetGroupID: category,
  //           AssetTypeID: unitType,
  //           ProjectID: projectId,
  //           SuffixID,
  //           OBJECTID,
  //         };
  //       }
  //     }
  //   );
  // }

  const getUserRoleType = () => {
    //check User's Role
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      console.log("$$$USER :", user);
      const role = intelliFiberUserRoles.find(
        (item) => item.UserID === user?.userID
      );
      console.log("$$$USER Role:", role);
      if (role) {
        return role.RoleName ? role.RoleName : "";
      }
    }
    return "";
  };

  const handleCategoryChange = (event: SelectChangeEvent<string>) => {
    setCategory(event.target.value as string);
  };

  const handleUnitTypeChange = (
    event: SelectChangeEvent<typeof selectedUnitType>
  ) => {
    const {
      target: { value },
    } = event;
    setSelectedUnitType(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );

    // setUnitType(event.target.value as string);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleNewProject = () => {
    setNewUnitOpen(true);
  };

  const handleClose = () => {
    setCategory("");
    // setUnitType("");
    setSelectedUnitType([]);
    setUnits([]);
    setOpen(false);
    setEditProps(null);
    setEditDialogOpen(false);
  };

  const handleNewUnitClose = () => {
    setNewUnitOpen(false);
    setCategory("");
    setAssetType("");
  };

  const addProjectUnit = async () => {
    if (!category || selectedUnitType.length === 0) {
      return;
    }

    console.log("SEL UNITS:", selectedUnitType);

    let _delUnits = _.difference(initUnitType, selectedUnitType);
    let _addUnits = _.difference(selectedUnitType, initUnitType);

    const newUnits = _addUnits.map((item) => ({
      AssetGroupID: category,
      AssetTypeID: item,
      ProjectID: projectId,
    }));

    _delUnits = getProjectUnitsIDs(category, _delUnits);

    console.log("DEL UNITS:", _delUnits);

    const delUnits = _delUnits.map((item) => ({
      AssetGroupID: category,
      AssetTypeID: item.AssetTypeID,
      ProjectID: projectId,
      OBJECTID: item.OBJECTID,
    }));

    if (addProjectUnitsV2 && deleteIntelliFiberUnit) {
      try {
        console.log("Adding project units", units);
        let addRes = true,
          delRes = true;
        if (newUnits.length > 0) {
          addRes = await addProjectUnitsV2(newUnits);
        }
        if (delUnits.length > 0) {
          delRes = await deleteIntelliFiberUnit(delUnits);
        }

        if (addRes && delRes) {
          handleSuccess();
        }
      } catch (error) {
        console.error(
          "An error occurred while adding/deleting project units:",
          error
        );
        // handle error as needed
      }
    }
  };

  const addNewUnit = async () => {
    if (!category || !assetType) {
      return;
    }
    if (
      assetTypes.find(
        (at) => at.AssetName === assetType && at.AssetGroupID === category
      )
    ) {
      console.log("Duplicate Unit Type Added.......");
      setAlertMessage({
        message: "Unit Type Already Exist, Please Check!!",
        type: "error",
      });
      setShowAlert(true);
      return;
    }
    let newID;
    if (generateNewUnitID) {
      newID = generateNewUnitID();
    }
    const newUnits = [
      {
        AssetTypeID: newID,
        AssetName: assetType,
        AssetGroupID: category,
      },
    ];

    if (addNewUnitsV2) {
      try {
        console.log("Adding project units", newUnits);
        let addRes = true;

        if (newUnits.length > 0) {
          addRes = await addNewUnitsV2(newUnits);
        }

        if (addRes) {
          handleNewSuccess();
          console.log(addRes);
          console.log(assetTypes);
          // getAssetTypesV2?.();
          // setTimeout(() => {
          //   fetchProjectAssets();
          // }, 3000);
        }
      } catch (error) {
        console.error(
          "An error occurred while adding/deleting project units:",
          error
        );
        // handle error as needed
      }
    }
  };

  const handleSuccess = () => {
    setCategory("");
    // setUnitType("");
    setSelectedUnitType([]);
    setUnits([]);
    // setDeleteRecords([]);
    handleClose();
    setAlertMessage({
      message: "Changes have been saved successfully",
      type: "success",
    });
    setShowAlert(true);
    fetchAssets();
    fetchProjectAssets();
  };

  const handleNewSuccess = () => {
    setCategory("");
    setAssetType("");
    handleNewUnitClose();
    setAlertMessage({
      message: "New Unit has been saved successfully",
      type: "success",
    });
    setShowAlert(true);
    fetchAssets();
    fetchProjectAssets();
  };

  const selectProjectUnits = (category: string) => {
    console.log("PRJ Asset:", projectAssets);
    console.log("PRJ RW Asset:", projectRawAssets);
    const initTypes = projectRawAssets
      .filter(({ AssetGroupID }) => AssetGroupID === category)
      .map(({ AssetTypeID }) => AssetTypeID);
    setInitUnitType(initTypes);
    setSelectedUnitType(initTypes);
  };

  const getProjectUnitsIDs = (category: string, units: string[]) => {
    console.log("PRJ Asset:", projectAssets);
    console.log("PRJ RW Asset:", projectRawAssets);
    const resultIDS = projectRawAssets
      .filter(
        ({ AssetGroupID, AssetTypeID }) =>
          AssetGroupID === category &&
          units.some((item) => item === AssetTypeID)
      )
      .map(({ OBJECTID, AssetTypeID }) => ({
        OBJECTID,
        AssetTypeID,
      }));
    return resultIDS;
  };

  const handleTextFieldChange = (event) => {
    const { name, value } = event.target;
    // console.log(`Setting`, name, value);
    setAssetType((prevVal) => value);
    setFormChanged(true);

    const regex =
      /^(?:\+?[A-Z0-9]+(?: [A-Z0-9]+)*\d*(?:-[A-Z0-9]+)?(?:\([A-Z0-9X\-\/.]+["']?\))*(?:\(\d+\))?|[A-Z0-9]+ [A-Z]+ [A-Z]+ \(\d+["']\))$/;
    if (regex.test(value)) {
      setInvalidInput(false);
    } else {
      console.log(`Invalid input! Please try again.::<b>${value}</b>`);
      setInvalidInput(true);
    }
  };

  useEffect(() => {
    setUnits([]);
    //get project Units, if any and set Init values
    if (category) {
      selectProjectUnits(category);
    }
    console.log("Clearing Earlier units", units);
  }, [category]);

  useEffect(() => {
    const addUnits = async () => {
      if (units.length > 0 && !units[0].SuffixID) {
        console.log("Adding project units", units);
        if (addProjectUnitsV2) {
          let res = await addProjectUnitsV2(units);
          if (res) {
            handleSuccess();
          }
        }
      }
    };
    addUnits();
  }, [units]);

  useEffect(() => {
    if (editDialogOpen === true) {
      setOpen(true);
      setCategory(editProps.groupId);
      // setUnitType(editProps.typeId);
      // setConfigSuffixes(configSuffixesValues());
    }
  }, [editDialogOpen]);

  const configSuffixesValues = (deletedRecords?: string[]): string[] => {
    console.log("SUFF", editProps.groupId, editProps.typeId, deletedRecords);
    let suffixes =
      projectAssets
        ?.find(({ AssetGroupID }) => AssetGroupID === editProps.groupId)
        ?.AssetTypes?.find(
          ({ AssetTypeID }) => AssetTypeID === editProps.typeId
        )
        ?.Suffixes?.map(({ SuffixID }) => SuffixID) || [];

    console.log("## After FILLL: ", suffixes);
    return suffixes;
  };

  const getSelectedNames = (selected: string[]): string[] => {
    let result;
    if (category && assetTypes) {
      result = assetTypes
        .filter(
          ({ AssetGroupID, AssetTypeID }) =>
            AssetGroupID === category && selected.includes(AssetTypeID)
        )
        .map(({ AssetTypeID, AssetName }) => AssetName);
    }
    return result ? result.sort().join(", ") : [];
  };

  return (
    <div>
      <Box
        display="flex"
        width="100%"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ margin: 1, padding: 3 }}
      >
        <Button
          variant="contained"
          color="secondary"
          sx={{ margin: 1, padding: 1, display: "flex", alignItems: "center" }}
          onClick={handleNewProject}
          disabled={getUserRoleType() !== "Central GIS Team"}
        >
          <AddIcon sx={{ marginRight: 1 }} />
          <Typography variant="button" sx={{ fontSize: "0.875rem" }}>
            ADD NEW UNIT
          </Typography>
        </Button>

        {/* <Button
          variant='contained'
          color='secondary'
          sx={{ margin: 1, padding: 1, display: "flex", alignItems: "center" }}
          onClick={handleClickOpen}
          disabled={getUserRoleType() !== "Central GIS Team"}
        >
          <AddIcon sx={{ marginRight: 1 }} />
          <Typography variant='button' sx={{ fontSize: "0.875rem" }}>
            ADD PROJECT UNIT
          </Typography>
        </Button> */}
        <SearchInput searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        BackdropProps={{
          onClick: handleClose,
        }}
        //@ts-ignore
        disablebackdropclick={false}
      >
        <DialogTitle>
          {editDialogOpen === true ? "Edit" : "Add"} Project Unit
        </DialogTitle>

        <DialogContent>
          <Grid
            spacing={2}
            container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
            // style={{width:"500px"}}
          >
            <Grid item sx={{ width: "400px" }} xs={12} sm={4}>
              <FormControl
                // disabled={editDialogOpen}
                required
                fullWidth
                sx={{ m: 1 }}
              >
                <InputLabel>Please select the category</InputLabel>
                <Select
                  value={category}
                  onChange={handleCategoryChange}
                  label="Please select the category"
                >
                  <MenuItem value="">
                    <em>Select category type</em>
                  </MenuItem>
                  {assetGroups &&
                    assetGroups.map(({ AssetGroupID, AssetGroupType }) => (
                      <MenuItem key={AssetGroupID} value={AssetGroupID}>
                        {AssetGroupType}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item sx={{ width: "400px" }} xs={12} sm={4}>
              <FormControl
                required
                fullWidth
                sx={{ m: 1 }}
                // disabled={!category || editDialogOpen}
                disabled={!category}
              >
                <InputLabel id="selectUnit">Select Unit(s)</InputLabel>
                <Select
                  labelId="selectUnit"
                  label="Select Unit"
                  multiple
                  value={selectedUnitType}
                  onChange={handleUnitTypeChange}
                  input={<OutlinedInput label="Tag" />}
                  renderValue={(selected) => getSelectedNames(selected)}
                  MenuProps={MenuProps}
                >
                  {category &&
                    assetTypes &&
                    assetTypes
                      .filter(
                        ({ AssetGroupID, AssetName }) =>
                          AssetGroupID === category
                      )
                      .map(({ AssetTypeID, AssetName }) => (
                        <MenuItem key={AssetTypeID} value={AssetTypeID}>
                          <Checkbox
                            checked={selectedUnitType.indexOf(AssetTypeID) > -1}
                          />
                          <ListItemText primary={AssetName} />
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>CANCEL</Button>
          <Button
            variant="contained"
            onClick={addProjectUnit}
            disabled={_.isEqual(initUnitType, selectedUnitType)}
          >
            {/* {editDialogOpen === true ? "Save" : "ADD PROJECT UNIT"} */}
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={newUnitOpen}
        onClose={handleNewUnitClose}
        BackdropProps={{
          onClick: handleNewUnitClose,
        }}
        //@ts-ignore
        disablebackdropclick={false}
      >
        <DialogTitle>Add New Unit</DialogTitle>

        <DialogContent>
          <Grid
            spacing={2}
            container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
            // style={{width:"500px"}}
          >
            <Grid item sx={{ width: "400px" }} xs={12} sm={4}>
              <FormControl
                // disabled={editDialogOpen}
                required
                fullWidth
                sx={{ m: 1 }}
              >
                <InputLabel>Please select the category</InputLabel>
                <Select
                  value={category}
                  onChange={handleCategoryChange}
                  label="Please select the category"
                >
                  <MenuItem value="">
                    <em>Select category type</em>
                  </MenuItem>
                  {assetGroups &&
                    assetGroups.map(({ AssetGroupID, AssetGroupType }) => (
                      <MenuItem key={AssetGroupID} value={AssetGroupID}>
                        {AssetGroupType}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item sx={{ width: "400px" }} xs={12} sm={4}>
              <FormControl
                required
                fullWidth
                sx={{ m: 1 }}
                // disabled={!category || editDialogOpen}
                disabled={!category}
              >
                {/* <InputLabel id='selectUnit'>Select Unit(s)</InputLabel> */}
                <TextField
                  onChange={handleTextFieldChange}
                  variant="outlined"
                  name="AssetType"
                  value={assetType}
                  // style={{ paddingRight: "20px" }}
                  label="Add Unit(s)"
                />
              </FormControl>
              {invalidInput && (
                <span style={{ color: "red" }}>Invalid input</span>
              )}
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleNewUnitClose}>CANCEL</Button>
          <Button
            variant="contained"
            onClick={addNewUnit}
            disabled={!formChanged || invalidInput}
          >
            {/* {editDialogOpen === true ? "Save" : "ADD PROJECT UNIT"} */}
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const SearchInput = ({ searchTerm, setSearchTerm }) => {
  return (
    <Paper
      component="form"
      sx={{
        margin: 1,
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: 300,
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Search by Unit/Unit Types"
        inputProps={{ "aria-label": "search google maps" }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
};

export default AddIntelliFiberUnit;
